<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="700px">
      <v-card>
        <!-- Cabeçalho -->
        <v-card-title class="primary white--text">
          <span class="text-h5 font-weight-bold">Duplicar Aula - Polivalência</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('dialogChange', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(enableSubmit)">
              <!-- Seção: Informações Básicas -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Informações da Aula
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <label class="info-label">Tipo de Aula:</label>
                        <p class="info-value">{{ aulaDuplicada.tipo_de_aula }}</p>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label class="info-label">Data da Aula</e-label>
                          <v-text-field
                            dense
                            outlined
                            v-model="data"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          :allowed-dates="allowedDates"
                          scrollable
                          locale="pt-BR"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="error" @click="modal = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)"
                            >Confirmar</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Seção: Horários -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Seleção de Horários
                  <e-help-tooltip :text="$constants.tooltips.aulas.duplicarAulaPolivalente" />
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-alert v-show="messageAlert" dense outlined type="warning" class="mb-4">
                    {{ messageAlert }}
                  </v-alert>

                  <div
                    v-for="item in JSON.parse(aulaDuplicada.horarios_extras)"
                    :key="item.id"
                    class="mb-4"
                  >
                    <e-label class="font-weight-medium">{{ getNomeDisciplina(item.id) }}</e-label>
                    <e-autocomplete
                      :items="disciplinaHorarios[item.id]"
                      outlined
                      label="Selecione um horário"
                      item-text="descricao"
                      item-value="id"
                      :value="horarios_selecionados_extras[item.id]"
                      return-object
                      dense
                      @change="
                        (val) => {
                          $set(horarios_selecionados_extras, item.id, val);
                          verifyHorariosSelectExtra(val, item.id);
                        }
                      "
                    />
                  </div>
                </v-card-text>
              </v-card>

              <!-- Seção: Planejamento por Disciplina -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Planejamento por Disciplina
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <div
                    v-for="(item, index) in JSON.parse(aulaDuplicada.horarios_extras)"
                    :key="index"
                    class="mb-6"
                  >
                    <v-subheader class="pl-0 font-weight-bold primary--text">
                      {{ getNomeDisciplina(item["id"]) }}
                    </v-subheader>

                    <v-card flat class="pa-4 grey lighten-4 rounded">
                      <!-- <div class="mb-3">
                        <label class="info-label">Conteúdo:</label>
                        <p class="text-body-2 mb-0">{{ JSON.parse(aulaDuplicada.conteudo_polivalencia)[index] || '-' }}</p>
                      </div> -->

                      <div class="mb-3">
                        <label class="info-label">Unidades Temáticas:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.unidades_tematicas)[index] || "-" }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <label class="info-label">Objetos do Conhecimento:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.objeto_conhecimento)[index] || "-" }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <label class="info-label">Habilidades:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.habilidades)[index] || "-" }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <label class="info-label">Objetivo de Aprendizagem:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.objetivo_de_aprendizagem)[index] || "-" }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <label class="info-label">Procedimentos Metodológicos:</label>
                        <p class="text-body-2 mb-0">
                          {{
                            parseJsonArray(aulaDuplicada.procedimentos_metodologicos)[index] || "-"
                          }}
                        </p>
                      </div>

                      <div>
                        <label class="info-label">Material de Apoio:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.material_de_apoio)[index] || "-" }}
                        </p>
                      </div>
                    </v-card>
                    <v-divider
                      v-if="index < JSON.parse(aulaDuplicada.horarios_extras).length - 1"
                      class="mt-4"
                    ></v-divider>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Seção: Avaliação da Aula (Geral) -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Avaliação da Aula
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <p class="text-body-1">{{ aulaDuplicada.avaliacao_da_aula || "-" }}</p>
                </v-card-text>
              </v-card>

              <v-divider class="my-6"></v-divider>
              <e-progresso-preenchimento
                :expectedItems="itemsEsperados"
                :filledItems="itemsPreenchidos"
                @total-filled-changed="
                  (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                "
              />

              <!-- Ações -->
              <v-card-actions class="px-0">
                <v-spacer></v-spacer>
                <v-btn color="error" outlined class="mr-3" @click="$emit('dialogChange', false)">
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  :disabled="desabilitarSalvamento || !totalmentePreenchido || temConflito"
                  type="submit"
                  depressed
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Salvar
                </v-btn>
              </v-card-actions>
            </form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    />
    <aulas-em-conflitos v-model="sheetAulasEmConflito" :aulas="aulasEmConflito" />
  </v-row>
</template>

<script>
import AulasEmConflitos from "@/components/Aulas/AulasEmConflitos.vue";

export default {
  components: {
    AulasEmConflitos,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAulas: {
      type: Object,
      require: true,
    },
    horarios: {
      type: Array,
      require: true,
    },
    disciplinas: {
      type: Array,
    },
    allowedDates: {
      type: Function,
    },
    tipoAula: {
      type: String,
      require: false,
    },
    gestaoDeAulaCompleta: {
      type: Object,
      require: true,
    },
    todosEventos: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.array_horarios_extras = JSON.parse(this.aulaDuplicada.horarios_extras).map((item) => ({
      id: item.id,
      array: [],
    }));
    this.buscarTodosHorarios();
    this.carregarTodosHorariosDisciplinas();
  },
  data() {
    return {
      array_horarios_extras: [],
      editarHorario: false,
      horarios_selecionados_extras: [],
      messageAlert: null,
      desabilitarSalvamento: false,
      date: null,
      data: null,
      modal: false,
      menu: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      horariosSabado: [],
      horariosFiltrados: [],
      aulasEmConflito: [],
      sheetAulasEmConflito: false,
      temConflito: false,
      objectModal: {
        title: "Duplicar aula - Polivalência",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      itemsEsperados: [],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
      todosHorariosDisponiveis: [],
      disciplinaHorarios: {},
    };
  },
  created() {
    this.itemsEsperados = [{ label: "Data", value: "dataAulaDuplicada" }];

    this.$watch("dataAulaDuplicada", (val) => {
      this.$toggleItemPreenchidoBarraProgresso("dataAulaDuplicada", !!val, this.itemsPreenchidos);
    });

    this.$watch(
      "form",
      (val) => {
        if (val && val.horarios_extras) {
          try {
            const horariosExtras = JSON.parse(val.horarios_extras);

            this.itemsEsperados = this.itemsEsperados.filter(
              (item) => !item.value.startsWith("horarios_selecionados_extras")
            );

            horariosExtras.forEach((item) => {
              const disciplinaNome = this.getNomeDisciplina(item.id);
              const horarioItem = {
                label: `Horário - ${disciplinaNome}`,
                value: `horarios_selecionados_extras[${item.id}]`,
                disciplinaId: item.id,
              };

              this.itemsEsperados.push(horarioItem);

              this.$watch(`horarios_selecionados_extras.${item.id}`, (val) => {
                const shouldAdd = !!val;
                this.$toggleItemPreenchidoBarraProgresso(
                  horarioItem.value,
                  shouldAdd,
                  this.itemsPreenchidos
                );
              });
            });
          } catch (error) {
            this.$handleError(error);
          }
        }
      },
      { immediate: true }
    );
  },
  watch: {
    data(val) {
      console.log("📅 Data alterada (duplicar):", val);
      const count = 0;
      JSON.parse(this.aulaDuplicada.horarios_extras).forEach((element) => {
        if (this.horarios_selecionados_extras[element.id]) {
          this.pesquisaAulas(this.horarios_selecionados_extras[element.id].id, element.id, val);
        }
      });
    },
    dialog: {
      handler(val) {
        if (!val) {
          // Limpa os estados quando o modal é fechado
          this.dataAulaDuplicada = null;
          this.data = null;
          this.horarios_selecionados_extras = [];
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
          this.messageAlert = null;
          this.desabilitarSalvamento = false;
        }
      },
    },
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
    dataAulaDuplicada(value) {
      if (!value) {
        this.data = null;
        this.horariosFiltrados = [];
        return;
      }
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data = data_old.replaceAll("/", "/");
      // Chama o filtro de horários pelo dia da semana
      const diaDaSemana = date.getDay(); // 0 = domingo, 1 = segunda, ..., 6 = sábado
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
      this.carregarTodosHorariosDisciplinas();
    },
  },
  methods: {
    parseJsonArray(value) {
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [value];
      }
    },
    toYMD(v) {
      if (!v) return "";

      if (typeof v === "string") {
        if (/^\d{4}-\d{2}-\d{2}/.test(v)) {
          return v.slice(0, 10);
        }

        const parts = v.split("/");
        if (parts.length === 3) {
          const [dia, mes, ano] = parts;
          return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
        }

        if (v.length > 10) return v.slice(0, 10);
      }

      const d = v instanceof Date ? v : new Date(v);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },

    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      try {
        if (!this.gestaoDeAulas?.gestao?.relacoesDiasHorarios) {
          this.horariosFiltrados = [];
          return;
        }

        let horariosDoDia = [];

        if (diaDaSemana === 5) {
          // Sábado: pega todos os horários da gestão
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios.map(
            (relacao) => relacao.horario
          );
        } else {
          // Outros dias: filtra os horários relacionados ao dia específico
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }

        this.horariosFiltrados = horariosDoDia;
      } catch (error) {
        this.horariosFiltrados = [];
      }
    },

    async buscarTodosHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.getAllHorarios();
        const horariosData = response.data || response;
        this.todosHorariosDisponiveis = horariosData.map((h) => ({
          id: h.id,
          turno_id: h.turno_id,
          descricao: h.descricao || "Horário",
          final: h.final,
          inicio: h.inicio,
        }));

        return this.todosHorariosDisponiveis;
      } catch (error) {
        this.$handleError(error);
        return [];
      }
    },

    async getFilteredHorariosByDisciplineModal(disciplineId) {
      if (!this.data || !this.gestaoDeAulaCompleta?.relacoesDiasHorarios) {
        return [];
      }

      const diaDaSemana = new Date(this.toYMD(this.data)).getDay();
      const dataFormatada = this.toYMD(this.data);
      const evento = (this.todosEventos || []).find((ev) => this.toYMD(ev.data) === dataFormatada);

      if (evento && (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1)) {
        if (!this.todosHorariosDisponiveis || this.todosHorariosDisponiveis.length === 0) {
          await this.buscarTodosHorarios();
        }
        return this.todosHorariosDisponiveis || [];
      }

      const filteredRelations = this.gestaoDeAulaCompleta.relacoesDiasHorarios.filter(
        (r) => r.dia.id === diaDaSemana && r.disciplina.id === disciplineId
      );

      const horariosFiltrados = filteredRelations.map((r) => r.horario);

      return horariosFiltrados;
    },

    async carregarTodosHorariosDisciplinas() {
      if (this.aulaDuplicada && this.aulaDuplicada.horarios_extras) {
        const horariosExtrasParsed = JSON.parse(this.aulaDuplicada.horarios_extras);

        await Promise.all(
          horariosExtrasParsed.map((item) => this.carregarHorariosDisciplina(item.id))
        );
      }
    },

    async carregarHorariosDisciplina(disciplineId) {
      this.$set(
        this.disciplinaHorarios,
        disciplineId,
        await this.getFilteredHorariosByDisciplineModal(disciplineId)
      );
    },

    getHorariosDaAula(aula) {
      try {
        if (!aula?.horarios_extras) return [];
        return JSON.parse(aula.horarios_extras);
      } catch (error) {
        return [];
      }
    },

    getArrayHorarios(idsHorarios) {
      if (!idsHorarios || !this.horariosFiltrados) return [];
      return idsHorarios
        .map((id) => this.horariosFiltrados.find((horario) => horario.id === id))
        .filter(Boolean);
    },

    valoresComuns(array1, array2) {
      return array1.filter((valor) => array2.includes(valor));
    },
    verifyHorariosSelectExtra(item, disciplinaId) {
      try {
        if (!item) return;

        // Inicializa o array se necessário
        if (!this.array_horarios_extras.some((i) => i.id === disciplinaId)) {
          this.array_horarios_extras.push({
            id: disciplinaId,
            array: [],
          });
        }

        // Atualiza o horário selecionado para esta disciplina (como um array de 1 elemento para o backend)
        const disciplina = this.array_horarios_extras.find((i) => i.id === disciplinaId);
        disciplina.array = [item.id];

        // Verifica conflitos com outras disciplinas
        this.verificarConflitosHorarios(disciplinaId);

        // Verifica disponibilidade na data selecionada
        if (this.data) {
          this.pesquisaAulas(item.id, disciplinaId);
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    verificarConflitosHorarios(disciplinaId) {
      const currentDisciplina = this.array_horarios_extras.find((item) => item.id === disciplinaId);
      if (!currentDisciplina || currentDisciplina.array.length === 0) return;

      const horarioId = currentDisciplina.array[0];

      const conflito = this.array_horarios_extras.some(
        (item) => item.id !== disciplinaId && item.array.includes(horarioId)
      );

      if (conflito) {
        const horarioObj = this.horariosFiltrados.find((h) => h.id === horarioId);
        this.$toast.danger(
          `Outro componente curricular já está usando o horário ${horarioObj?.descricao || ""}!`
        );

        // Limpa a seleção
        this.$set(this.horarios_selecionados_extras, disciplinaId, null);
        currentDisciplina.array = [];
      }
    },
    getObjHorario(id) {
      if (id) {
        const dis = this.horarios.filter((obj) => obj.id === id);
        return dis[0].descricao;
      }
    },
    getNomeDisciplina(id) {
      if (!this.gestaoDeAulas || !Array.isArray(this.gestaoDeAulas.disciplinas_com_descricao)) {
        return "Componente Curricular não encontrado (dados incompletos)";
      }
      const dis = this.gestaoDeAulas.disciplinas_com_descricao.filter((obj) => obj.id === id);
      return dis.length > 0 ? dis[0].descricao : "Componente Curricular não encontrado";
    },
    async pesquisaAulas(horarioId, disciplinaId, data) {
      console.log("🔍 Verificando conflito de aula na duplicação...");
      const data_aula = this.data.split("/").reverse().join("-");
      const turma_id = this.aulaDuplicada.turma_id;

      if (!data_aula || !horarioId || !this.aulaDuplicada) return;

      try {
        const response = await this.$services.aulasService.pesquisarAulasEmConflitosPoli(
          data_aula,
          horarioId,
          turma_id,
          0
        );

        console.log("📡 Resposta da API (duplicar):", response.data);

        this.messageAlert = null;
        this.desabilitarSalvamento = false;
        this.temConflito = false;

        if (response.data.conflito) {
          const aulasConflito = response.data.aulas || [];
          console.log("⚠️ Conflito encontrado na duplicação:", aulasConflito);

          const conflitosFormatados = aulasConflito.map((conflito) => ({
            id: conflito.id,
            professor: {
              nome: conflito.instrutor,
            },
            situacao: conflito.situacao || "Aguardando",
            data: data_aula,
            turma: {
              descricao: conflito.turma,
              franquia: {
                descricao: conflito.franquia,
              },
            },
            disciplina: {
              descricao: conflito.disciplina_descricao,
            },
            horario: conflito.horario,
          }));

          this.aulasEmConflito = conflitosFormatados;
          this.sheetAulasEmConflito = true;
          this.temConflito = true;
          this.messageAlert =
            "Já existe aula registrada nessa data com esses mesmos horários, selecione uma outra data!";
          this.desabilitarSalvamento = true;
          console.log("✅ Exibindo sheet de conflitos na duplicação");
        } else {
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
          console.log("✅ Nenhum conflito encontrado na duplicação");
        }
      } catch (error) {
        console.error("❌ Erro ao verificar conflito na duplicação:", error);
        this.$handleError(error);
      }
    },
    enableSubmit() {
      // Verifica se todos os horários estão preenchidos para cada disciplina
      const horariosExtras = JSON.parse(this.aulaDuplicada.horarios_extras || "[]");

      const todosPreenchidos = horariosExtras.every(
        (item) => !!this.horarios_selecionados_extras[item.id]
      );
      if (this.data && todosPreenchidos) {
        this.confirmDialog = !this.confirmDialog;
        this.aulaDuplicada.data = this.dataAulaDuplicada;
      } else {
        this.$toast.danger("Preencha todos os horários de todas as disciplinas.");
      }
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando a Aula");
      try {
        this.aulaDuplicada.horarios_extras = JSON.stringify(
          this.array_horarios_extras.map((item) => ({
            id: item.id,
            array: item.array, // array de ids dos horários selecionados
          }))
        );

        this.aulaDuplicada.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.aulaDuplicada.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.aulaDuplicada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.aulaDuplicada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
        this.aulaDuplicada.disciplina_id = this.gestaoDeAulas.disciplina_id;
        this.aulaDuplicada.turma_id = this.gestaoDeAulas.turma_id;
        this.aulaDuplicada.instrutor_id = this.gestaoDeAulas.instrutor_id;

        const response =
          this.tipoAula === "complementar"
            ? await this.$services.aulasComplementaresService.criar(this.aulaDuplicada)
            : await this.$services.aulasService.criar(this.aulaDuplicada);
        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        this.$toast.success("Aula duplicada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style scoped>
.info-field {
  margin-bottom: 12px;
}
.info-label {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}
.info-value {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
}
</style>
